import React from 'react';
import { tilPengerFormat } from '../../Shared/Scripts/Utilities/Formatters';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';
import { connect } from 'react-redux';
import { VeilederVgsUtenUrAppState } from '../Store';
import { toggleUtbetalingsplan, toggleVilkar } from '../Store/Valg/Actions';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { ResultatGx } from '../Ids';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface GxResultOwnProps {
    basisstotte: number;
    skolepengelan: number;
    eventId: string | null;
}

type GxResultatProps = MapStateToProps & MapDispatchToProps & GxResultOwnProps;

class GxResultatComponent extends React.PureComponent<GxResultatProps> {
    constructor(props: GxResultatProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }

    componentDidMount(): void {
        updateLiveMessage();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }

    render(): JSX.Element {
        const { skolepengelan, basisstotte, visVilkar, epiContext, eventId } = this.props;
        const { locale } = this.props.epiContext;

        return (
            <div id={ResultatGx} className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine">
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--with-space">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                            {contentResolver(epiContext, 'tittelResultatX')}
                        </h3>
                        {contentResolver(epiContext, 'brodtekstResultatX')}
                    </div>
                    <div className="c-veileder__content c-veileder__content--indented c-veileder__content--with-space-desktop">
                        <div className="c-veileder__resultat-tekst">
                            <span>{tilPengerFormat(basisstotte, locale)}</span>
                            <span className="c-veileder__tekst c-veileder__tekst--postfix">
                                &nbsp;{epiContext.valuta}
                            </span>
                        </div>
                        <p className="c-veileder__tekst c-veileder__tekst--tett">
                            {contentResolver(epiContext, 'ytelserBasisstotteRx')}
                        </p>
                    </div>
                </div>
                <div className="c-veileder__panel-row c-veileder__panel-row--right">
                    <div className="c-veileder__content c-veileder__content--indented c-veileder__content--with-space">
                        <div className="c-veileder__resultat-tekst">
                            <span>{tilPengerFormat(skolepengelan, locale)}</span>
                            <span className="c-veileder__tekst c-veileder__tekst--postfix">
                                &nbsp;{epiContext.valuta}
                            </span>
                        </div>
                        <p className="c-veileder__tekst c-veileder__tekst--tett">
                            {contentResolver(epiContext, 'ytelserSkolepengerRx')}
                        </p>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--linkarea">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                            {contentResolver(epiContext, 'lenketekstVilkar')}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkar}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={resolveRawText(epiContext, 'modalVilkarAriaLabel')}
                            eventId={eventId}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'modalVilkarTittel', 2)}
                                contentinnhold={contentResolver(epiContext, 'modalVilkarContent', 2)}
                            />
                        </ModalCompontent>
                    </div>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederVgsUrDto>;
    visVilkar: boolean;
}

interface MapDispatchToProps {
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederVgsUtenUrAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visVilkar: state.valg.visVilkar,
        };
    },
    { toggleUtbetalingsplan, toggleVilkar, updateZIndex },
)(GxResultatComponent);
